import {
  DocumentOrganizationKeys,
  FilterDocument,
  GroupByMode,
  SmartList,
  SortingMode,
} from '@griply/types';

const getDefaultFilterDocument = (): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Priority,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {},
});

export const getFilterDocument = (smartList?: SmartList): FilterDocument => {
  const base = getDefaultFilterDocument();

  return {
    ...base,
    ...(smartList?.filterDocument ?? {}),
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(smartList?.filterDocument?.filters ?? {}),
    },
  };
};
